
export const RESPONSE_CODE = {
  FAILED: 0,
  SUCCESS: 1,
}

/** Response format returned by the V2 backend. Legacy APIs do not have this field. */
export const API_RESPONSE_VERSION = {
  V2: '2.0',
} as const;

export interface IResDataDefault<T = any[]> {
  totalPages: number,
  totalItems: number,
  page: number,
  result: T
}

export interface IResponseApi<T = IResDataDefault, TMess = any[]> {
  code: number,
  version?: string,
  errorCode: string | null,
  statusCode?: number, // Header status code
  messages: TMess,
  data: T,
}

/**
 * A legacy endpoint may have a `code` field with a different meaning. Only the
 * explicitly versioned V2 contract uses `code === 1` as the success condition.
 */
export function isV2ApiResponse(response: unknown): response is IResponseApi {
  return !!response
    && typeof response === 'object'
    && String((response as {version?: unknown}).version) === API_RESPONSE_VERSION.V2;
}

export function getApiResponseMessages(response: {messages?: unknown}): string[] {
  const {messages} = response;
  if (Array.isArray(messages)) {
    return messages.filter((message): message is string => typeof message === 'string' && message.trim().length > 0);
  }
  return typeof messages === 'string' && messages.trim() ? [messages] : [];
}

/** Business failure returned with HTTP 200 by a V2 endpoint. */
export class V2ApiResponseError extends Error {
  constructor(readonly response: IResponseApi) {
    const messages = getApiResponseMessages(response);
    super(messages[0] || 'V2 API request failed.');
  }
}
